import "../styles.css";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCategories } from "../../actions/categories";
import { getState } from "../../actions/popup";

export default function New({ allCategories }) {
  const dispatch = useDispatch();
  let [myCategories, setMyCategories] = useState([]);

  document.title = "Choose Business Category";

  const categories = allCategories,
    setSelected = ({ _id, index }) => {
      let el = document.getElementsByClassName("singleCategory")[index],
        cValue = el.getElementsByTagName("input")[0].checked;
      el.getElementsByTagName("input")[0].checked = !cValue;

      !myCategories.includes(_id)
        ? setMyCategories([...myCategories, _id])
        : setMyCategories([...myCategories].filter((c) => c !== _id));
    };

  const handleSubmitCategories = () => {
      dispatch(getCategories(myCategories));
      dispatch(getState(false));
    },
    [searchData, setSearchData] = useState(""),
    [searchResults, setSearchResults] = useState([]),
    handleSearch = (e) => {
      setSearchData(e.target.value.trim());
      if (searchData.length > 1) handleSearchResults();
    },
    handleSearchResults = () => {
      let searchRes = categories.filter(
        (category) =>
          category.categoryName
            .toLowerCase()
            .search(searchData.toLowerCase()) !== -1
      );
      setSearchResults(searchRes);
    },
    [connectionFailed, setConnectionFailed] = useState(false);
  useEffect(() => {
    if (!categories || categories.length === 0) setConnectionFailed(true);
  }, [categories]);

  return (
    <div className="BusinessCategory">
      <div className="PopupTransparentBg"></div>
      <div className="BusinessCategoryContent">
        <div>
          <h5>
            <b>Choose Your Business Category</b>
          </h5>
          <div>
            <form action="/" method="POST" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                name="searchCategory"
                placeholder="Search"
                onChange={(e) => handleSearch(e)}
              />
              <input
                style={{ cursor: "pointer"}}
                onClick={handleSubmitCategories}
                value="Save"
              />
            </form>
          </div>
        </div>
        <div>
          {!searchData
            ? categories.map((category, index) => (
                <div
                  className="singleCategory"
                  key={index}
                  onClick={() => {
                    setSelected({ _id: category._id, index });
                  }}
                >
                  <input
                    type="checkbox"
                    name={category.categoryName}
                    id={category._id}
                  />
                  <label style={{ fontWeight: 400 }} htmlFor={category.value}>
                    {category.categoryName}
                  </label>
                </div>
              ))
            : searchData && searchResults.length === 0
            ? "No results match your search."
            : searchResults.map((category, index) => (
                <div
                  className="singleCategory"
                  key={index}
                  onClick={() => {
                    setSelected({ _id: category._id, index });
                  }}
                >
                  <input
                    type="checkbox"
                    name={category.categoryName}
                    id={category._id}
                  />
                  <label style={{ fontWeight: 400 }} htmlFor={category.value}>
                    {category.categoryName}
                  </label>
                </div>
              ))}
          {connectionFailed && (
            <span style={{ color: "red" }}>Waiting for connection...</span>
          )}
        </div>
      </div>
    </div>
  );
}
